import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {CardTitle} from "./card-title";
import classNames from "classnames";
import {TAG_TITLE} from "../../../app/consts";
import styles from './card-title.module.scss';

export class TrapezoidCardTitleProps extends BaseProps {
  title: String;
  className: String;
}

export const TrapezoidCardTitle = ({title, className}: TrapezoidCardTitleProps) => {
  const cardTitleProps = {
    title: title,
    className: classNames(styles.trapezoid_card_title, className),
    TitleTag: TAG_TITLE.div
  }

  return (
    <CardTitle {...cardTitleProps}/>
  )
}
